<template>
  <div class="expandable-text">
    <div class="text-container">
      <p
        ref="textRef"
        :class="{ collapsed: !expanded }"
        :style="!expanded ? { '-webkit-line-clamp': maxLines } : {}"
      >
        {{ text }}
      </p>
      <button
        v-if="isOverflowing"
        @click="toggle"
        class="toggle-button"
        :title="expanded ? 'Свернуть' : 'Развернуть'"
      >
        <span>{{ expanded ? '▲' : '▼' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandableText",
  props: {
    text: {
      type: String,
      required: true,
    },
    maxLines: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      expanded: false,
      isOverflowing: false,
    };
  },
  mounted() {
    this.checkOverflow();
  },
  watch: {
    text() {
      this.$nextTick(() => this.checkOverflow());
    },
    maxLines() {
      this.$nextTick(() => this.checkOverflow());
    },
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    checkOverflow() {
      const el = this.$refs.textRef;

      if (!el) return;

      const fullHeight = el.scrollHeight;

      // Временное применение ограничения строк
      el.style.display = "-webkit-box";
      el.style.webkitBoxOrient = "vertical";
      el.style.webkitLineClamp = this.maxLines;
      el.style.overflow = "hidden";

      // Ждем перерисовки, чтобы измерить высоту
      this.$nextTick(() => {
        const limitedHeight = el.getBoundingClientRect().height;

        // Снимаем ограничения
        el.style.display = "";
        el.style.webkitBoxOrient = "";
        el.style.webkitLineClamp = "";
        el.style.overflow = "";

        // Проверяем, есть ли переполнение
        this.isOverflowing = fullHeight > limitedHeight;
      });
    },
  },
};
</script>

<style scoped>
.expandable-text {
  width: 100%;
}

.text-container {
  position: relative;
  width: 100%;
  padding-right: 1.5rem;
}

p {
  margin: 0;
  transition: max-height 0.3s ease;
  overflow: hidden;
  word-break: break-word;
}

/* Скрывает лишние строки */
.collapsed {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.toggle-button {
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.2rem;
  line-height: 1;
  color: #21BA45  ;
}
</style>
